import {getUserPremiumLevel, isUserLoggedIn} from '@Libraries/user.library';
import {USER_PREMIUM_LEVELS} from '@Utils/user.util';
import type {AudienceEmailState} from '@Components/email-marketing-campaign-audience/email-marketing-campaign-audience.types';

export interface EventWizardRegistrationsProps {
  // add props here
}

export interface EventRegistrationFields {
  areRegistrationsRequired: boolean;
  email: boolean;
  name: boolean;
  phone: boolean;
  registerBtnText: string;
  customBtnTexts?: string[];
  registerBtnLink?: string;
}

export const CUSTOM_EVENT_GUEST_INFO_PHONE_TOGGLED = 'guest_info_phone_toggle_wizard';

export interface EventRegistrations {
  id: number; // ID from EmailMarketingCampaignMailingListContactVO
  idMailingList: number;
  state: AudienceEmailState;
  displayableBounceReason: string;
  email: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
}

export const getDefaultRegistrationButtonTextOptions = (): string[] => {
  return [
    window.i18next.t('pmwjs_register'),
    window.i18next.t('pmwjs_sign_up'),
    window.i18next.t('pmwjs_rsvp'),
    window.i18next.t('pmwjs_join'),
    window.i18next.t('pmwjs_claim_spot'),
  ];
}

export const getRegistrationButtonTextOptions = (customText?: string[]): string[] => {
  const base = getDefaultRegistrationButtonTextOptions();
  return [...new Set([...base, ...(customText ?? [])])];
};

export const registerTextDropdownID = 'RegisterTextDropdownID';

export const shouldUpsellUserForNumRegistrations = (): boolean => {
  if (!isUserLoggedIn()) {
    return false;
  }
  return getUserPremiumLevel() === USER_PREMIUM_LEVELS.PAYG;
};

export const shouldUpsellUserForRegistrationOptions = (): boolean => {
  return getUserPremiumLevel() === USER_PREMIUM_LEVELS.PAYG;
};
